/* Lancer dispensing hub — collection template. Picker, accordion, sticky bar, GA4.
   Mirrors the Manitowoc hub engine (collection-hub-howdy-v2.js); reuses collection-hub-howdy-v2.css. */
(function(){
  'use strict';
  var root = document.querySelector('.hb-collection-v2');
  if (!root) return;

  var WEBPRICE_HTML = '<span class="hb-collection-v2-webprice">'
    + '<span class="hb-collection-v2-webprice-label">Web Price</span>'
    + '<button type="button" class="hb-collection-v2-webprice-q" aria-label="Why is this the Web Price?">?</button>'
    + '<span class="hb-collection-v2-webprice-tip" role="tooltip">'
    + '<span class="hb-collection-v2-webprice-tip-text">This is the manufacturer’s Minimum Advertised Price (MAP). Want a better price? Request a custom quote — our team can unlock exclusive pricing, volume discounts, and project rates reserved for direct requests. Free and no obligation.</span>'
    + '<button type="button" class="hb-collection-v2-webprice-tip-link" data-open-quote>Request an unadvertised deal ›</button>'
    + '</span></span>';

  function fireGA4Event(name, params){
    if (typeof gtag !== 'function') return;
    gtag('event', name, Object.assign({event_callback:function(){}, event_timeout:1000, transport_type:'beacon'}, params || {}));
  }

  /* ---------- picker data (verified active handles; prices hydrate live below) ---------- */
  var CDN = 'https://cdn.shopify.com/s/files/1/0627/8725/6536/files/';
  var MODELS = [
    {m:'FS60 Flavor Select', family:'combo', ice:'cube/nugget', valves:32, cooling:'self', price:29933, handle:'lancer-fs60-dispenser-32-brand-24-bonus', img:CDN+'75-9999-090908.jpg?v=1761356610'},
    {m:'FS30 Flavor Select', family:'combo', ice:'nugget', valves:16, cooling:'self', price:14003, handle:'lancer-fs30-dispenser-16-brand-12-bonus-ada-nugget-ice', img:CDN+'85-14816n-12-a.jpg?v=1761355362'},
    {m:'IBD60 Nugget', family:'combo', ice:'nugget', valves:20, cooling:'self', price:15688, handle:'lancer-ibd60-dispenser-20-valve-nugget-ice', img:CDN+'1739870108_75-9999-090301_1.jpg?v=1761355261'},
    {m:'IBD22CB Cold Carb', family:'combo', ice:'cube', valves:6, cooling:'remote', price:5785, handle:'lancer-ibd22cb-cold-carb-dispenser-6-valve', img:CDN+'85-4546cb-111.jpg?v=1761355287'},
    {m:'IBD22H', family:'combo', ice:'cube', valves:6, cooling:'self', price:3186, handle:'lancer-ibd22h-dispenser-cube-ice-6-valve-85-4526h-111-gb', img:CDN+'85-4526h-111-gb.jpg?v=1761356448'},
    {m:'CED 2508', family:'countertop', ice:'', valves:8, cooling:'self', price:5450, handle:'lancer-ced-2508-post-mix-dispenser-8-valves', img:CDN+'85-2508a-111-gb.jpg?v=1761355390'},
    {m:'CED 2300', family:'countertop', ice:'', valves:6, cooling:'self', price:2800, handle:'lancer-dispenser-ced-2300-6-valve-standard-performance', img:CDN+'1739870087_85-1596A-211-GB_1.webp?v=1762121715'},
    {m:'ICDI 2308 Ice-Cooled', family:'drop-in', ice:'ice-cooled', valves:8, cooling:'self', price:3913, handle:'drop-in-dispenser-8-valve-coke-graphic-icd-2300-11l07118', img:CDN+'rsz_icdi2300_8v_standard_r_0220.webp?v=1762110741'},
    {m:'Bevariety Drop-In', family:'drop-in', ice:'', valves:6, cooling:'self', price:6228, handle:'lancer-bevariety-dispenser-6-brand', img:CDN+'1739870111_85-20406-0-0-31E_1.jpg?v=1761356515'},
    {m:'301 Island Base', family:'drop-in', ice:'', valves:1, cooling:'self', price:408, handle:'lancer-301-island-base-dispenser-1-valve', img:CDN+'85-3131-111.jpg?v=1761355304'},
    {m:'TST Iced Tea', family:'specialty', ice:'', valves:8, cooling:'self', price:5472, handle:'lancer-tst-tea-dispenser-8-brands', img:CDN+'75-3260-30124-80-03_1.jpg?v=1761355281'},
    {m:'Orange Juice Dispenser', family:'specialty', ice:'', valves:2, cooling:'self', price:4740, handle:'lancer-orange-juice-dispenser-2-valves-portion-control', img:CDN+'1739870050_85-3332_1.jpg?v=1761356489'},
    {m:'Bridge Tower', family:'tower', ice:'', valves:10, cooling:'remote', price:5877, handle:'lancer-bridge-tower-10-flavors', img:CDN+'1739870141_LancerBridgeTower_1.jpg?v=1761356585'}
  ];

  /* hydrate live price/availability from Shopify so the picker never shows stale numbers */
  MODELS.forEach(function(md){
    fetch('/products/' + md.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p) return; md.price = Math.round(p.price/100); md.available = p.available;
    }).catch(function(){});
  });

  var STEPS = [
    {q:'What type of dispenser do you need?', help:'This sets the machine family.', key:'family', opts:[
      {v:'combo', t:'Ice + beverage combo', d:'Makes ice and pours soda (IBD / FS)'},
      {v:'drop-in', t:'Drop-in', d:'Mounts flush into a counter'},
      {v:'countertop', t:'Countertop', d:'Self-contained CED / CCD'},
      {v:'specialty', t:'Specialty', d:'Iced tea, juice, frozen'},
      {v:'tower', t:'Tower', d:'Remote-fed dispense tower'}
    ]},
    {q:'How many flavors (valves)?', help:'Match to your menu and traffic — size for your busiest day.', key:'valves', opts:[
      {v:4, t:'4 or fewer', d:'Café / small bar'},
      {v:6, t:'6', d:'Restaurant'},
      {v:8, t:'8', d:'QSR / busy bar'},
      {v:12, t:'10–12+', d:'C-store / concession'}
    ]},
    {q:'How will it be cooled?', help:'Self-contained is simplest; remote / cold-carb needs a line chiller.', key:'cooling', opts:[
      {v:'self', t:'Self-contained / ice-cooled', d:'Cools on board'},
      {v:'remote', t:'Remote / cold-carb', d:'Pair with a line chiller'},
      {v:'any', t:'Not sure yet', d:''}
    ]}
  ];

  var state = {}, stepIdx = 0, started = false;
  function $(id){ return document.getElementById(id); }
  var stepsEl = $('picker-steps');

  if (stepsEl) {
    var renderStep = function(){
      var s = STEPS[stepIdx], prog = $('picker-progress'), html = '';
      for (var i = 0; i < STEPS.length; i++) html += '<span class="dot' + (i <= stepIdx ? ' done' : '') + '"></span>';
      html += '<span class="label">Step ' + (stepIdx + 1) + ' of ' + STEPS.length + '</span>';
      prog.innerHTML = html;
      $('picker-q').textContent = s.q;
      $('picker-help').textContent = s.help;
      var opts = '';
      s.opts.forEach(function(o, i){
        opts += '<button type="button" class="hb-collection-v2-picker-opt" data-i="' + i + '"><span class="t">' + o.t + '</span>' + (o.d ? '<span class="d">' + o.d + '</span>' : '') + '</button>';
      });
      $('picker-opts').innerHTML = opts;
      $('picker-back').hidden = stepIdx === 0;
      $('picker-calc').classList.remove('show');
      $('picker-opts').querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){ pick(s, parseInt(btn.dataset.i, 10)); });
      });
    };

    var pick = function(s, i){
      var o = s.opts[i];
      if (!started) { started = true; fireGA4Event('picker_start'); }
      state[s.key] = o.v;
      stepIdx++;
      fireGA4Event('picker_step_' + stepIdx);
      if (stepIdx >= STEPS.length) { showResults(); } else { renderStep(); }
    };

    var showResults = function(){
      var need = state.valves || 6;
      var pool = MODELS.filter(function(md){
        if (state.family && md.family !== state.family) return false;
        if (state.cooling && state.cooling !== 'any' && md.cooling !== state.cooling) return false;
        return true;
      });
      if (!pool.length) pool = MODELS.filter(function(md){ return md.family === state.family; });
      if (!pool.length) pool = MODELS.slice();
      var matches = pool.sort(function(a, b){ return Math.abs(a.valves - need) - Math.abs(b.valves - need); }).slice(0, 3);
      stepsEl.style.display = 'none';
      var r = $('picker-results');
      r.classList.add('show');
      $('picker-results-sub').textContent = 'Matched on ' + (state.family || '') + ' · ' + need + '+ valves · ' + (state.cooling === 'remote' ? 'remote/cold-carb' : (state.cooling === 'self' ? 'self-contained' : 'any cooling')) + '. Prices include freight.';
      var html = '';
      matches.forEach(function(md, i){
        html += '<div class="hb-collection-v2-result-card' + (i === 0 ? ' best' : '') + '">'
          + (i === 0 ? '<span class="hb-collection-v2-result-badge">Best match</span>' : '')
          + '<div class="hb-collection-v2-result-img"><img src="' + md.img + '" alt="Lancer ' + md.m + ' commercial beverage dispenser" loading="lazy" width="240" height="240"></div>'
          + '<div><span class="hb-collection-v2-result-series">Lancer</span><h4 class="hb-collection-v2-result-model">' + md.m + '</h4></div>'
          + '<div class="hb-collection-v2-result-specs">'
          + '<span>Flavors <b>' + md.valves + ' valve' + (md.valves > 1 ? 's' : '') + '</b></span>'
          + '<span>Ice <b>' + (md.ice ? md.ice : '—') + '</b></span>'
          + '<span>Cooling <b>' + (md.cooling === 'remote' ? 'Remote' : 'Self') + '</b></span>'
          + '<span>Type <b>' + md.family + '</b></span>'
          + '</div>'
          + '<div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap"><span class="hb-collection-v2-result-price">$' + md.price.toLocaleString() + '</span>' + WEBPRICE_HTML + '<span class="hb-collection-v2-result-stock">✓ In stock · Free freight</span></div>'
          + '<div class="hb-collection-v2-result-ctas">'
          + '<a href="/products/' + md.handle + '" class="hb-collection-v2-btn-primary" data-ga4="picker_result_view_product" data-model="' + md.m + '">View dispenser</a>'
          + '<button type="button" class="hb-collection-v2-btn-secondary" data-open-quote data-ga4="picker_result_quote" data-model="' + md.m + '">Get a quote</button>'
          + '</div></div>';
      });
      $('result-cards').innerHTML = html;
      fireGA4Event('picker_result', {family: state.family, valves: need, cooling: state.cooling});
      var sc = $('sticky-cta'); if (sc) sc.textContent = 'Your matches ↑';
      bindAnchors($('result-cards'));
      $('result-cards').querySelectorAll('[data-ga4]').forEach(function(el){
        el.addEventListener('click', function(){ fireGA4Event(el.dataset.ga4, {model: el.dataset.model}); });
      });
    };

    $('picker-back').addEventListener('click', function(){ if (stepIdx > 0) { stepIdx--; renderStep(); } });
    $('picker-restart').addEventListener('click', function(){
      state = {}; stepIdx = 0; started = false;
      $('picker-results').classList.remove('show');
      stepsEl.style.display = '';
      var sc = $('sticky-cta'); if (sc) sc.textContent = 'Build my fountain →';
      renderStep();
    });
    renderStep();
  }

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('.hb-collection-v2-acc-trigger').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.hb-collection-v2-acc-item');
      var body = item.querySelector('.hb-collection-v2-acc-body');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
    });
  });

  /* ---------- sticky mobile bar ---------- */
  var hero = $('hero-primary-cta'), bar = $('sticky-bar'), picker = $('picker');
  if ('IntersectionObserver' in window && hero && bar && picker) {
    var heroVisible = true, pickerVisible = false;
    var update = function(){ bar.classList.toggle('is-visible', !heroVisible && !pickerVisible); };
    new IntersectionObserver(function(e){ heroVisible = e[0].isIntersecting; update(); }, {rootMargin: '0px'}).observe(hero);
    new IntersectionObserver(function(e){ pickerVisible = e[0].isIntersecting; update(); }, {rootMargin: '-80px 0px 0px 0px'}).observe(picker);
  }

  /* ---------- Web Price tooltips ---------- */
  function closeWebprices(except){ document.querySelectorAll('.hb-collection-v2-webprice.open').forEach(function(w){ if (w !== except) w.classList.remove('open'); }); }
  function flipWebprice(w){ var r = w.getBoundingClientRect(); w.classList.toggle('flip', r.left + 280 > window.innerWidth); }
  document.addEventListener('mouseover', function(e){ var w = e.target.closest('.hb-collection-v2-webprice'); if (w) flipWebprice(w); });
  document.addEventListener('click', function(e){
    var q = e.target.closest('.hb-collection-v2-webprice-q');
    if (q) { e.preventDefault(); e.stopPropagation(); var w = q.closest('.hb-collection-v2-webprice'); var opening = !w.classList.contains('open'); closeWebprices(w); flipWebprice(w); w.classList.toggle('open'); if (opening) fireGA4Event('hub_webprice_open'); return; }
    if (e.target.closest('[data-open-quote]')) { closeWebprices(); return; }
    if (!e.target.closest('.hb-collection-v2-webprice')) closeWebprices();
  });

  /* ---------- GA4 on static CTAs ---------- */
  root.querySelectorAll('[data-ga4-static]').forEach(function(el){
    el.addEventListener('click', function(){ fireGA4Event(el.dataset.ga4Static, el.dataset.handle ? {handle: el.dataset.handle, position: el.dataset.position} : {}); });
  });

  /* ---------- smooth scroll for in-page anchors ---------- */
  function bindAnchors(scope){
    (scope || root).querySelectorAll('a[href^="#"]').forEach(function(a){
      if (a.dataset.bound) return; a.dataset.bound = '1';
      a.addEventListener('click', function(ev){ var id = a.getAttribute('href'); if (id.length < 2) return; var t = document.getElementById(id.slice(1)); if (t) { ev.preventDefault(); t.scrollIntoView({behavior:'smooth'}); } });
    });
  }
  bindAnchors();
  var sticky = $('sticky-bar'); if (sticky) bindAnchors(sticky);
})();
